import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { BENCHMARK_PEER_LABEL } from 'pages/pga-coach/dashboard/performance-benchmarks/constants'
import BenchmarkScaleTrack, {
  BenchmarkScaleTick,
} from 'pages/pga-coach/dashboard/performance-benchmarks/benchmark-scale-track'
import {
  formatBenchmarkValue,
  getDetailScalePercent,
} from 'pages/pga-coach/dashboard/performance-benchmarks/utils'

const BenchmarkScale = ({ metric, classes }) => {
  const gettingStartedPercent = getDetailScalePercent(
    metric.gettingStartedValue,
    metric,
  )
  const medianPercent = getDetailScalePercent(metric.medianValue, metric)
  const top10Percent = getDetailScalePercent(metric.top10Value, metric)

  return (
    <Box className={classes.scaleSection}>
      <Box className={classes.metricValueRow}>
        <Typography className={classes.metricValue}>
          {formatBenchmarkValue(metric.coachValue, metric.unit)}
        </Typography>
        <Box className={classes.scaleValuesRow}>
          <Box className={classes.scaleValueGroup}>
            <Typography className={classes.scaleValueLabel}>
              {BENCHMARK_PEER_LABEL}
            </Typography>
            <Typography className={classes.scaleValue}>
              {formatBenchmarkValue(metric.medianValue, metric.unit)}
            </Typography>
          </Box>
          <Box className={classes.scaleValueGroup}>
            <Typography className={classes.scaleValueLabel}>Top 10%</Typography>
            <Typography className={classes.scaleValue}>
              {formatBenchmarkValue(metric.top10Value, metric.unit)}
            </Typography>
          </Box>
        </Box>
      </Box>

      <BenchmarkScaleTrack metric={metric} className={classes.scaleTrack}>
        <BenchmarkScaleTick percent={medianPercent} />
        <BenchmarkScaleTick percent={top10Percent} />
      </BenchmarkScaleTrack>

      <Box className={classes.scaleLabelsRow}>
        <Typography
          className={classes.scaleLabel}
          style={{ left: `${gettingStartedPercent}%` }}
        >
          Getting started
        </Typography>
        <Typography
          className={`${classes.scaleLabel} ${classes.scaleLabelCenter}`}
          style={{ left: `${medianPercent}%` }}
        >
          {BENCHMARK_PEER_LABEL}
        </Typography>
        <Typography
          className={`${classes.scaleLabel} ${classes.scaleLabelEnd}`}
          style={{ left: `${top10Percent}%` }}
        >
          Top 10%
        </Typography>
      </Box>
    </Box>
  )
}

BenchmarkScale.propTypes = {
  metric: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

export default BenchmarkScale
